import MultiRatioInput from './index';
const MultiRatioInputMeta = {
  id: 'multiRatioInput',
  component: MultiRatioInput,
  isFormEditor: true,
  hideLabel: true,
  bindings: [{
    id: 'v-model',
    prop: 'value',
    event: 'change',
    main: true,
    required: true
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'string',
      title: '当前值'
    }, {
      id: 'useRadio',
      type: 'string',
      title: '使用三按钮单选框',
      default: 'false'
    }, {
      id: 'schema',
      type: 'object',
      description: 'schema 取title和id进行展示'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '数据发生修改时触发，$event 为新的值'
  }]
};
export default MultiRatioInputMeta;
//# sourceMappingURL=meta.js.map
